import {useState, useEffect, useCallback} from 'react';
import {useLocation, useHistory} from 'react-router-dom';
import * as QueryString from 'query-string';
import {flattenObject, removeEmptyValueObject} from '../helpers';

const getParams = search => {
  const query = {};
  const queryString = QueryString.parse(search);
  Object.entries(queryString).forEach((array, index) => {
    query[array[0]] = array[1];
  });
  const {size} = queryString;
  const page = parseInt(queryString.page);
  const q = {
    ...query,
    page,
    size,
  };
  return q;
};

const setParams = (params, history, initValue) => {
  const parameters = [];
  if (
    params.page !== null &&
    params.page !== undefined &&
    params.size !== undefined
  ) {
    Object.entries(params).forEach((array, index) => {
      parameters.push(`${array[0]}=${array[1]}`);
    });
    history.replace('?' + parameters.join('&'));
  } else {
    history.replace(`?page=${initValue.page}&size=${initValue.size}`);
  }
};

const useQuery = (initValue: any, sortValue:string  ) => {
  const {search} = useLocation();
  const history = useHistory();
  const isempty = getParams(search).size === undefined;
  const [filtersValues, setvalue] = useState(
    !isempty ? getParams(search) : initValue
  );
  const sort = sortValue;
  useEffect(() => {
    if (isempty) {
      setParams(
        removeEmptyValueObject(flattenObject({...initValue, sort})),
        history,
        initValue
      );
    }
  }, []);
  const setFiltersValues = useCallback(
    newValue => {
      const flattenValue = removeEmptyValueObject(flattenObject({...newValue, sort}));
      setParams(flattenValue, history, newValue);
      setvalue(flattenValue);
    },
    [initValue]
  );
  return {filtersValues, setFiltersValues};
};
export default useQuery;
